import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { AutorizacionPasoPage } from "@/features/autorizacion/components/AutorizacionPasoPage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/autorizacion")({
  loader: ({ context: { queryClient }, params: { id } }) =>
    queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: AutorizacionPasoPage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
